import React from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { CheckCircle, Error } from '@mui/icons-material';
import { styled } from '@mui/system';

const ToastContent = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  '& svg': {
    marginRight: theme.spacing(1),
  },
}));

export const showSuccessToast = (message: string): void => {
  toast.success(
    <ToastContent>
      {message}
    </ToastContent>,
    {
      position: 'bottom-center',
      autoClose: 3000,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: true,
      theme: 'light',
    }
  );
};

export const showErrorToast = (message: string): void => {
  toast.error(
    <ToastContent>
      <Error style={{ color: 'red' }} />
      {message}
    </ToastContent>,
    {
      position: 'bottom-center',
      autoClose: 5000,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: true,
      theme: 'light',
      icon: false,
    }
  );
};

const CustomNotification: React.FC = () => {
  return <ToastContainer />;
};

export default CustomNotification;

